import { useState, useCallback } from 'react';
import { getAllBundleCourses } from '../../../service/BundleService';

export const useBundleHistory = () => {
    const [courseList, setCourseList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);

    const getBundlesHistory = useCallback(async (bundleId, page = 0, size = 10, sortBy = 'createdAt', sortDir = 'asc', search = '', active = true) => {
        try {
            const response = await getAllBundleCourses(bundleId, page, size, sortBy, sortDir, search, active);
            const rawList = response?.content ?? (Array.isArray(response) ? response : []);

            const mapped = rawList.map((user, index) => ({
                id: user.courseId,
                srno: page * size + index + 1, 
                name: user.title,
                level: user.level,
                status: user.active ? "Active" : "Removed"
            }));

            setCourseList(mapped);
            setTotalElements(response?.totalElements ?? 0);
            return response;

        } catch (error) {
            console.error("Error loading bundles:", error);
            setCourseList([]);
        }
    }, []);

    return {
        courseList,
        totalElements,
        getBundlesHistory,
    };
};